import Vue from 'vue'
import main from './gacnio-activity.vue'
import "lib-flexible/flexible.js";
import  VConsole  from  'vconsole';
if(process.env.VUE_APP_ENV==='dev'){
    new VConsole();
}


new Vue({
    render: h => h(main)
}).$mount('#app')

